import React from "react";
import { notification } from "antd";

import { ArgsProps } from "antd/lib/notification";

type NotificationProps = ArgsProps;

const openSuccessNotification = (config: NotificationProps): void => {
  notification.success({
    ...config,

    message: "Success",
    description: config.message,
  });
};

const openInfoNotification = (config: NotificationProps): void => {
  notification.info({
    ...config,

    message: "Info",
    description: config.message,
  });
};

const openWarningNotification = (config: NotificationProps): void => {
  notification.warning({
    ...config,

    message: "Warning",
    description: config.message,
  });
};

const openErrorNotification = (config: NotificationProps): void => {
  notification.error({
    ...config,

    message: "Error",
    description: config.message,
  });
};

export const notificationController = {
  success: openSuccessNotification,
  info: openInfoNotification,
  warning: openWarningNotification,
  error: openErrorNotification,
};
